import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { addMonthsToDate, formatDate } from 'utils/datetime'

export const useGetStepsByPeriod = () => {
  const { period } = usePeriodContext()

  const start = period?.startDate
  const phase2Start = addMonthsToDate(start, 1)
  const phase2End = addMonthsToDate(period?.endDate, -1)
  const end = period?.endDate

  return [
    {
      title: formatDate(start, 'MMMM'),
      description: ['Perencanaan Kinerja'],
    },
    {
      title: `${formatDate(phase2Start, 'MMMM')} - ${formatDate(
        phase2End,
        'MMMM'
      )}`,
      description: [
        'Persiapan Praktik Kinerja',
        'Pelaksanaan Observasi Praktik Kinerja',
        'Pelaksanaan Tindak Lanjut Praktik Kinerja',
      ],
    },
    {
      title: formatDate(end, 'MMMM'),
      description: ['Penetapan Predikat Kinerja'],
    },
  ]
}
